import { createWebHistory, createRouter } from "vue-router";

import Home from './pages/Home.vue'
import Projects from './pages/Projects.vue'
import About from './pages/About.vue'
import P404 from './pages/404.vue'

const routes = [
  {
    path: '/',
    component: Home,
    name: 'Home'
  },
  {
    path: '/projects',
    component: Projects,
    name: 'Projects'
  },
  {
    path: '/about',
    component: About,
    name: 'About'
  },
  {
    path: '/:catchAll(.*)',
    component: P404,
    name: '404'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
  mode: 'history',
})

export default router
